import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Editor from 'react-simple-wysiwyg';

// @mui material components
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import Footer from 'examples/Footer';

import CrudService from 'services/cruds-service';
import { useMaterialUIController } from 'context';
import { useLocation } from 'react-router-dom';
import MDAlert from 'components/MDAlert';
import '../../style.css'

function CreateTemplate() {
    let { state } = useLocation()
    const navigate = useNavigate();
    const [templateName, setTemplateName] = useState('');
    const [templateContent, setTemplateContent] = useState('');
    const [error, setError] = useState('');
    const [notification, setNotification] = useState({
        value: false,
        text: '',
    })
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    useEffect(() => {
        if (!state) return
        setNotification({
            value: state.value,
            text: state.text,
        })
    }, [state])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (!templateName || !templateContent) {
                setNotification({
                    value: true,
                    text: 'Please fill in all fields'
                });
                return;
            }

            await CrudService.createCampaignTemplate({
                template_name: templateName,
                template_content: templateContent
            });

            navigate('/campaign/template', {
                state: {
                    value: true,
                    text: 'Template created successfully'
                }
            });

        } catch (err) {
            console.error(err);
            setNotification({
                value: true,
                text: err.message || 'Error creating template'
            });
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {notification.value && (
                <MDAlert color="info" my="20px">
                    <MDTypography variant="body2" color="white">
                        {notification.text || ''}
                    </MDTypography>
                </MDAlert>
            )}
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Create Campaign Template
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={4} pb={3} px={3}>
                                <MDBox component="form" role="form" onSubmit={handleSubmit}>
                                    <MDBox mb={4}>
                                        <MDInput
                                            type="text"
                                            label="Template Name"
                                            value={templateName}
                                            onChange={(e) => setTemplateName(e.target.value)}
                                            fullWidth
                                        />
                                    </MDBox>
                                    <MDBox mb={4}>
                                        <Editor
                                            value={templateContent}
                                            onChange={(e) => setTemplateContent(e.target.value)}
                                            containerProps={{
                                                style: {
                                                    border: '1px solid #ddd',
                                                    borderRadius: '4px',
                                                    color: darkMode ? '#fff' : '#000',
                                                    resize: 'vertical',
                                                    height: 'calc(100vh - 460px)',
                                                    fontFamily: "Roboto, Helvetica, Arial, sans-serif"
                                                }
                                            }}
                                        />
                                    </MDBox>
                                    {error && (
                                        <MDBox mb={2}>
                                            <MDTypography variant="caption" color="error">
                                                {error}
                                            </MDTypography>
                                        </MDBox>
                                    )}
                                    <MDBox mt={4} mb={1} display="flex" justifyContent="space-between">
                                        <MDButton
                                            variant="gradient"
                                            color="secondary"
                                            onClick={() => navigate('/campaign/template')}
                                        >
                                            Cancel
                                        </MDButton>
                                        <MDButton
                                            variant="gradient"
                                            color="info"
                                            type="submit"
                                        >
                                            Create Template
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default CreateTemplate;
